// @flow
import loadable from '@loadable/component';
import HeroBanner from 'components/HeroBanner';
import type {
  BlokComponentPropsType,
  BlokComponentType,
  SimpleContentType,
  TestimonialType,
  ParagraphWithImageType,
  CardsType
} from 'components/types';
import renderComponent from 'components/editable/renderComponent';
import * as componentKeys from 'componentKeys';

type BlokPropsType = {
  body: BlokComponentType<>[],
  call_to_action: [?BlokComponentType<SimpleContentType>],
  hero_content: [?BlokComponentType<SimpleContentType>],
  post_body: [
    ?BlokComponentType<
      SimpleContentType | ParagraphWithImageType | TestimonialType | CardsType
    >
  ]
};

const Page = {
  asyncComponentName: 'Page',
  AsyncComponent: loadable(() => import('./Page'))
};
const BlogAggregatePosts = {
  asyncComponentName: 'BlogAggregatePosts',
  AsyncComponent: loadable(() => import('../AggregatePosts'))
};
const BlogAggregateCategory = {
  asyncComponentName: 'BlogAggregateCategory',
  AsyncComponent: loadable(() => import('../AggregateCategory'))
};
const SubscribeForm = {
  asyncComponentName: 'SubscribeForm',
  AsyncComponent: loadable(() => import('../../SubscribeForm'))
};
const SatoriCode = {
  asyncComponentName: 'SatoriCode',
  AsyncComponent: loadable(() => import('../../SatoriCode'))
};

const componentMap = {
  [componentKeys.BLOG_AGGREGATE_POSTS]: BlogAggregatePosts,
  [componentKeys.BLOG_AGGREGATE_CATEGORY]: BlogAggregateCategory,
  [componentKeys.SUBSCRIBE_FORM_BLOCK]: SubscribeForm,
  [componentKeys.BLOG_AGGREGATE_CATEGORY]: Page,
  [componentKeys.SATORI_CODE]: SatoriCode
};

const BlogAggregatePage = ({
  blok: { body, hero_content: heroContent = [undefined] },
  id
}: BlokComponentPropsType<BlokPropsType>) => {
  let paragraphWithImageIsRight = true;
  return (
    <div id={id}>
      <HeroBanner blok={heroContent[0]} isCurved />
      {body &&
        body.map((bodyBlok) => {
          let isRight;
          if (bodyBlok.component === componentKeys.PARAGRAPH_WITH_IMAGE) {
            isRight = paragraphWithImageIsRight;
            paragraphWithImageIsRight = !paragraphWithImageIsRight;
          }
          return renderComponent(
            bodyBlok,
            {
              customPath: 'components/editable/blog/AggregatePage/index.jsx',
              key: bodyBlok._uid,
              isRight
            },
            componentMap
          );
        })}
    </div>
  );
};

export default BlogAggregatePage;
